import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./rolesSlice";

const selectDomain = (state) => state.roles || initialState;

export const makeSelectAll = createSelector(selectDomain, (state) => state.all);

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectChosenRole = createSelector(
  selectDomain,
  (state) => state.chosen_roles
);

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);
